import React, { useEffect } from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import HeadingH1 from "../../../utls/HeadingH1";

const GovernmentTravelBanner = () => {
  const bannerImage =
    "https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Gornment%20Travel.webp";

  useEffect(() => {
    // Preload the image
    const img = new Image();
    img.src = bannerImage;
  }, []);

  return (
    <div className="container-fluid ctm-banner position-relative p-0">
      <img
        src={bannerImage}
        alt="Government Travel Banner"
        className="w-100"
        fetchpriority="high"
        loading="eager"
      />
      <div className="ctm-text position-absolute text-white  mt-3">
        <p className="fs4 text-uppercase busy grotesk-headings">Government Travel</p>
        <HeadingH1 className="banner-headings w-100">
          Seamless Journeys Start with Blueberry Travel
        </HeadingH1>
        <div className="d-flex common-second-content">
          <div className="ornge-border"></div>
          <div className="second-content">
            Are your government travel plans meeting the mark? From booking to execution, we
            ensure your teams reach their destinations efficiently, on time, and within budget.
          </div>
        </div>
      </div>
    </div>
  );
};

export default GovernmentTravelBanner;
